import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { registrationServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const registrationInstance = axios.create({
  baseURL: registrationServiceUrl,
  headers,
})

registrationInstance.interceptors.request.use(requestInterceptor, error => Promise.reject(error))

registrationInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default registrationInstance
